/**
 * Local persistence adapter for workflow tasks.
 * Replace with REST implementation using the same public API.
 */

const STORAGE_PREFIX = 'mf_workflow_tasks_v1_';
const LOCK_PREFIX = 'mf_workflow_lock_v1_';

function rid(residentId) {
  return String(residentId);
}

function storageKey(residentId) {
  return `${STORAGE_PREFIX}${rid(residentId)}`;
}

function lockKey(residentId, workflowKey) {
  return `${LOCK_PREFIX}${rid(residentId)}_${workflowKey}`;
}

/**
 * @param {string|number} residentId
 * @returns {import('../../workflow/taskModel').WorkflowTask[]}
 */
export function loadTasksForResident(residentId) {
  try {
    const raw = localStorage.getItem(storageKey(residentId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('[TaskPersistence] load failed', e);
    }
    return [];
  }
}

/**
 * @param {string|number} residentId
 * @param {import('../../workflow/taskModel').WorkflowTask[]} tasks
 */
export function saveTasksForResident(residentId, tasks) {
  try {
    localStorage.setItem(storageKey(residentId), JSON.stringify(tasks));
    return true;
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error('[TaskPersistence] save failed', e);
    }
    return false;
  }
}

/**
 * Idempotency: has this workflow already been instantiated?
 * @param {string|number} residentId
 * @param {string} workflowKey
 */
export function isWorkflowInstantiated(residentId, workflowKey) {
  try {
    return localStorage.getItem(lockKey(residentId, workflowKey)) === '1';
  } catch {
    return false;
  }
}

/**
 * @param {string|number} residentId
 * @param {string} workflowKey
 */
export function markWorkflowInstantiated(residentId, workflowKey) {
  try {
    localStorage.setItem(lockKey(residentId, workflowKey), '1');
    return true;
  } catch {
    return false;
  }
}

/**
 * Clear workflow lock (e.g. tests). Not for production casual use.
 */
export function clearWorkflowLock(residentId, workflowKey) {
  try {
    localStorage.removeItem(lockKey(residentId, workflowKey));
  } catch {
    /* ignore */
  }
}
